import { IGenericObject } from "@sky-it-livedata-libraries/amplisky";
import { getAmplisky } from "./getAmplisky";

export const execQuery = async (queryDocument: any, variables: IGenericObject) => {
  const amplisky = getAmplisky();

  if (!amplisky) {
    throw new Error("GraphQL client not initialized");
  }

  return await amplisky.query(queryDocument?.trim()!, variables as IGenericObject)
}